import React, {useEffect, useState} from 'react';
import JobListTable from "@pages/job/list/JobListTable";
import {DEFAULT_PAGE_SIZE} from "@app/constants/Common";
import {requestGetJobList, requestGetRunJobList} from "@app/services/JobService";
import AdvanceSearchJobModal from "@pages/job/list/advancesearch/AdvanceSearchJobModal";
import RunJobListTable from "@pages/job/runjob/RunJobListTable";

const RunJobList = (props) => {
    const [runJobs, setRunJobs] = useState([]);
    // const [allJobIds, setAllJobIds] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [showAdvanceSearchModal, setShowAdvanceSearchModal] = useState(false);
    const [advanceSearchInput, setAdvanceSearchInput] = useState({});

    const searchJobList = (condition) => {
        setShowAdvanceSearchModal(false)
        setIsLoading(true)

        // let params = {page: page, size: DEFAULT_PAGE_SIZE}
        let params = {search_conditions: condition}
        requestGetRunJobList(params). then((res) => {
            const items = res.content.run_jobs.map((item, index) => {
                item.no = (res.content.page - 1) * DEFAULT_PAGE_SIZE + index + 1
                return item
            });
            setRunJobs(items);
            setTotalCount(res.content.totalCount)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            setRunJobs([]);
            setTotalCount(0)
            // setNumberPages(0);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    useEffect(() => {
        searchJobList()
    }, []);

    return (
        <div className='container-fluid'>
            <div className='card card-primary'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>{'Jobs Runned'}</h3>
                    <div className='card-tools'>
                        <a href='#'
                                onClick={() => {
                                    setShowAdvanceSearchModal(true)
                                    setAdvanceSearchInput({...advanceSearchInput})
                                }}>
                            <i className='fas fa-filter mr-2'/>
                        </a>
                    </div>
                </div>
                <div className='card-body'>
                    <div style={{position: 'relative'}}>
                        <RunJobListTable runJobs={runJobs}
                                      // allJobIds={allJobIds}
                                      totalCount={totalCount}
                                      onSearch={(condition) => searchJobList(condition)}/>
                        {isLoading &&
                        <div className={'col-sm-12 text-center'}
                             style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                            <div className='spinner-grow text-primary' role='status'>
                                <span className='sr-only'>Loading...</span>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RunJobList;
